import React from 'react';
import {Title, Paragraph} from './Basics';
import {Link, withRouter} from 'react-router';
import {translate} from './actions/translate.js';

import './Docs.css';

const Docs = ({location}) => {
  const {lang='de'} = location.query;
  const t=translate.bind(null, lang);
  return (
    <div className='Docs'>

      <div className="Docs__Navigation">
        <Link to={{ pathname: '/', query: { lang: lang } }} className="Docs__Navigation--back">‹ {t('docs link to prototype')}</Link>
      </div>

      <div className="Docs__Header">
        <Title>Multicle</Title>
        <Title level={4}>{t('docs subtitle')}</Title>
      </div>

      <div className="Docs__Content">

        <Title level={4}>
          {t('docs headline 1')}
        </Title>

        <Paragraph>
          {t('docs paragraph 1')}
        </Paragraph>

        <Paragraph>
          {t('docs paragraph 2')}
        </Paragraph>

        <Paragraph>
          {t('docs paragraph 3')}
        </Paragraph>

        <hr/>

        <Title level={4}>
          {t('docs headline 2')}
        </Title>

        <Paragraph>
          {t('docs paragraph 4')}
        </Paragraph>

        <ul className="Docs__List">
          <li><a href="https://twitter.com/ahaobschon">Michael Baumann</a></li>
          <li><a href="mailto:gerhard@interactivethings.com">Gerhard Bliedung</a></li>
          <li><a href="https://twitter.com/BeatGlogger">Beat Glogger</a></li>
          <li><a href="mailto:hoffmann@scitec-media.ch">Claudia Hoffmann</a></li>
          <li><a href="https://twitter.com/janwaechter">Jan Wächter</a></li>
          <li><a href="https://twitter.com/wiederkehr">Benjamin Wiederkehr</a></li>
        </ul>

      </div>

      <Paragraph>
        {t('docs paragraph 5')}
      </Paragraph>



      <div className="Docs__Button">
        <a href='mailto:info@multicle.news'>
          {t('docs button action')}
        </a>
      </div>


    </div>
  )
};

export default withRouter(Docs);



/** WEBPACK FOOTER **
 ** ./src/Docs.js
 **/